/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string };
type HookTuple = [
  response: vp.AccountUserPermissionsResponse,
  fetchData: (params: vp.AccountUserPermissionsRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchAccountUserPermissions: ApiHook = ({ api, bearer }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.AccountUserPermissionsResponse>({
    Username: '',
    Permissions: {},
    Success: false,
    ErrorMessage: '',
  });
  const [params, setParams] = useState<vp.AccountUserPermissionsRequest>({ EmailAddress: '' });
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();

  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchAccountUserPermissions(params, bearer, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldFetchData) void loadData();
    setShouldFetchData(false);

    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    (_params: vp.AccountUserPermissionsRequest) => {
      setParams(_params);
      setShouldFetchData(true);
    },
    () => {
      setResponse({
        Username: '',
        Permissions: {},
        Success: false,
        ErrorMessage: '',
      });
      setShouldFetchData(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchAccountUserPermissions);
